import {useSelector} from "react-redux";
import users from "../../users";
import {cn} from "../../../utils/utils";

import './button-v2.scss';

type Props = {
    title?: string;
    children?: React.ReactNode;
    onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    active?: boolean;
    disabled?: boolean;
    className?: string;
    size?: 'small' | 'medium' | 'large';
    variant?: 'danger' | 'primary' | 'secondary' | 'warning';
    width?: string | number;
    style?: React.CSSProperties;
    forceDarkMode?: 'light' | 'dark';
}

const ButtonV2 = ({
                      title,
                      children,
                      onClick,
                      active,
                      forceDarkMode,
                      disabled,
                      className,
                      size,
                      variant,
                      width,
                      style
                  }: Props) => {
    const darkMode = useSelector(users.selectors.isDarkMode);

    const isDarkMode = forceDarkMode ? (forceDarkMode === 'dark') : darkMode;


    return <button className={cn("button-v2", {"button-v2--dark": isDarkMode}, {"button-v2--active": active}, className,
        `button-v2--size-${size ?? 'medium'}`, `button-v2--type-${variant ?? 'primary'}`)}
                   style={{width: width, ...style}}
                   onClick={onClick} disabled={disabled} title={title}>
        {children}
    </button>;
}

export default ButtonV2;
